var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9873 33L30.8101 33C31.3554 33 31.7975 32.5579 31.7975 32.0126L31.7975 22.1392C31.7975 21.5939 31.3554 21.1519 30.8101 21.1519L16.9873 21.1519C16.442 21.1519 16 21.5939 16 22.1392L16 32.0126C16 32.5579 16.442 33 16.9873 33Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2636 21.3797L27.2636 20.3797L27.2636 20.3797L27.2636 21.3797ZM20.5334 21.3797L20.5334 22.3797L20.5334 22.3797L20.5334 21.3797ZM20.2529 21.1344L19.2529 21.1344L20.2529 21.1344ZM20.2529 18.1899L21.2529 18.1899L20.2529 18.1899ZM27.5441 18.1899L26.5441 18.1899L26.5441 18.1899L27.5441 18.1899ZM27.5441 21.1344L28.5441 21.1344L28.5441 21.1344L27.5441 21.1344ZM23.8985 15L23.8985 16L23.8985 15ZM27.2636 20.3797L20.5334 20.3797L20.5334 22.3797L27.2636 22.3797L27.2636 20.3797ZM21.2529 21.1344L21.2529 18.1899L19.2529 18.1899L19.2529 21.1344L21.2529 21.1344ZM26.5441 18.1899L26.5441 21.1344L28.5441 21.1344L28.5441 18.1899L26.5441 18.1899ZM23.8985 16C25.4892 16 26.5441 17.1017 26.5441 18.1899L28.5441 18.1899C28.5441 15.7546 26.3346 14 23.8985 14L23.8985 16ZM21.2529 18.1899C21.2529 17.1017 22.3078 16 23.8985 16L23.8985 14C21.4624 14 19.2529 15.7546 19.2529 18.1899L21.2529 18.1899ZM20.5334 20.3797C20.8012 20.3797 21.2529 20.5964 21.2529 21.1344L19.2529 21.1344C19.2529 21.9434 19.9558 22.3797 20.5334 22.3797L20.5334 20.3797ZM27.2636 22.3797C27.8412 22.3797 28.5441 21.9434 28.5441 21.1344L26.5441 21.1344C26.5441 20.5963 26.9958 20.3797 27.2636 20.3797L27.2636 22.3797Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircle);
export default __webpack_public_path__ + "static/media/lock-circle.76f74aace57cd9a176dcc5094eb11a0b.svg";
export { ForwardRef as ReactComponent };